import React, { useEffect, useState } from "react";
import useApp from "hooks/useApp";
import { Button, CommonAgreeLayer } from "components";
import styles from "../index.module.css";
import { selectedOrgsState, certTypeState, certFromState } from "../states";
import { useRecoilState, useRecoilValue } from "recoil";
import { useNavigate } from "react-router-dom";
import Lib from "library";
import Global from "library/Global";

const CertSelect = () => {
  const App = useApp();
  const navigate = useNavigate();
  const [showCommonTermsLayer, setShowCommonTermsLayer] = useState(false);
  const [showNaverTermsLayer, setShowNaverTermsLayer] = useState(false);
  const [certType, setCertType] = useRecoilState(certTypeState);
  const [supportIndividual, setSupportIndividual] = useState(false);
  const selectedOrgs = useRecoilValue(selectedOrgsState);
  const certFrom = useRecoilValue(certFromState);

  const onNext = async () => {
    if (certType === 0) {
      // 공동인증
      setShowCommonTermsLayer(true);
    } else if (certType === 1) {
      // 사설(네이버) 인증
      setShowNaverTermsLayer(true);
    } else if (certType === 2) {
      // 개별인증
      navigate("/data/dataEachTerms1");
    } else if (certType === 9999) {
      // 테스트베드용
      onAgree();
      // let params = [];

      // selectedOrgs.map((item) => {
      //   params.push({
      //     ca_code: "",
      //     clsfc_code: "",
      //     consent_nonce: "",
      //     org_code: item.insttCd,
      //     password: "",
      //     password_len: 0,
      //     signed_person_info_req: "",
      //     signed_person_info_req_len: 0,
      //     ucpid_nonce: "",
      //   });
      // });

      // if (params.length > 0) {
      //   App.showLoading();
      //   await Lib.post({
      //     url: "/api/data/lnkup/testbed/step1",
      //     data: params,
      //     onSuccess: (data) => {
      //       console.log("step1 호출 data");
      //     },
      //   });

      //   App.showLoading();
      //   await Lib.post({
      //     url: "/api/data/lnkup/testbed/step2",
      //     data: params,
      //     onSuccess: (data) => {
      //       App.showAlert("테스트베드 데이터 연동 성공.", () => {
      //         App.hideLoading();
      //         navigate("/");
      //       });
      //     },
      //   });
      // } else {
      //   App.showAlert("선택 된 기관이 없습니다.");
      // }
    }
  };

 

  const onAgree = () => {
    navigate("/data/transmitRequest");
  }

  useEffect(() => {
    if (selectedOrgs.length === 1 && selectedOrgs[0].authTpCd === "03") {
      // 개별인증 지원 여부
      setSupportIndividual(true);
    }
    console.log({ selectedOrgs });
  }, [selectedOrgs]);

  useEffect(() => {
    App.setHeader({
      show: true,
      title: <></>,
      left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
      right: "",
    });

    App.setShowNav(false);
    App.setMainClass("white");

    console.log(selectedOrgs);
  }, []);

  return (
    <div className="page">
      <div className="flex_1 padding">
        <div className={styles["count-group"]}>
          <p>인증 수단 선택</p>
          <div>
            <span>2</span>/4
          </div>
        </div>
        <ul className={`${styles.certification} mt_40`}>
          <li>
            <p>통합인증</p>
            <div className={styles.box} onClick={() => setCertType(0)}>
              <div className="flex-align_center">
                <span className={styles.circle}>
                  <i className="icon icon_document_lock" />
                </span>
                <p>공동인증서</p>
              </div>
              <i className={`checkMark${certType === 0 ? " on" : ""}`} />
            </div>
            <div className={styles.box} onClick={() => setCertType(1)}>
              <div className="flex-align_center">
                <span className={styles.circle}>
                  <i className="icon icon_naver" />
                </span>
                <p>네이버인증서</p>
              </div>
              <i className={`checkMark${certType === 1 ? " on" : ""}`} />
            </div>
            {/* 테스트베드 용 */}
            {Global.test && <div className={styles.box} onClick={() => setCertType(9999)}>
              <div className="flex-align_center">
                <span className={styles.circle}>
                  <i className="icon icon_star_badge" />
                </span>
                <p>테스트베드 인증</p>
              </div>
              <i className={`checkMark${certType === 9999 ? " on" : ""}`} />
            </div>}
          </li>
          {/* {
						supportIndividual &&
						<li>
							<p>개별인증</p>
							<div className={styles.box} onClick={() => setCertType(2)}>
								<div className="flex-align_center">
									<span className={styles.circle}>
										<i className="icon icon_star_badge" />
									</span>
									<p>개별인증서</p>
								</div>
								<i className={`checkMark${certType === 2 ? " on" : ""}`} />
							</div>
						</li>
					} */}
        </ul>
      </div>
      <div className="flex-shrink_0 padding">
        <Button
          className="btn btn--big"
          disabled={(() => typeof certType === "undefined")()}
          onClick={onNext}
        >
          다음
        </Button>
      </div>

      <CommonAgreeLayer
        title="공동인증서 인증을 위해 동의가 필요해요."
        buttonText="모두 동의하고 진행하기"
        show={showCommonTermsLayer}
        closeLayer={() => setShowCommonTermsLayer(false)}
        onAgree={onAgree}
        termsCategoryCd="CRTFCN"
      />
      <CommonAgreeLayer
        title="네이버 인증 필수 동의"
        show={showNaverTermsLayer}
        closeLayer={() => setShowNaverTermsLayer(false)}
        onAgree={onAgree}
        termsCategoryCd="NAVER_TERMS"
      />
    </div>
  );
};

export default CertSelect;
